// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1674":"1112d5966e698430","2451":"b26f9d5da0d83217"}[chunkId] + ".css";
};